import { Navigate, RouterProvider, createBrowserRouter } from 'react-router';
import DefaultLayout from './components/Layouts/Default';
import Home from './components/Pages/Home';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import './translations/i18n';
/* MUI Italia theme */
import { theme as muiItaliaTheme } from '@pagopa/mui-italia';
import FaqPage from './components/Pages/FaqPage';
import { useEffect } from 'react';

const customTheme = createTheme(muiItaliaTheme, {
  breakpoints: {
    values: {
      md: 1024
    }
  },
  palette: {
    customBlue: muiItaliaTheme.palette.augmentColor({
      color: {
        main: '#004C99',
        dark: '#134080',
        light: '#0066CC',
        contrastText: '#FFFFFF'
      },
      name: 'customBlue'
    }),
    newBlue: muiItaliaTheme.palette.augmentColor({
      color: { main: '#0B3EE3', contrastText: '#FFFFFF' },
      name: 'newBlue'
    })
  }
});

const router = createBrowserRouter([
  {
    path: '/',
    element: <DefaultLayout />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        path: '/faq',
        element: <FaqPage />
      }
    ]
  },
  {
    path: '*',
    element: <Navigate replace to={'/'} />
  }
]);

export const App = () => {
  // avoid scroll position restore on back/forward navigation
  useEffect(() => {
    window.history.scrollRestoration = 'manual';
  }, []);

  return (
    <>
      <ThemeProvider theme={customTheme}>
        <CssBaseline />
        <RouterProvider router={router} />
      </ThemeProvider>
    </>
  );
};
